import React, { useContext, useEffect, useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  LinearProgress,
} from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
// Helpers
import { percentageColor } from '../../../../helpers/helperFunctions';
import Paper from '@mui/material/Paper';

export default function PrdResultTable({ prdResult, months }) {
  const renderParentCell = () => {
    const render = months?.map((row) => (
      <>
        <TableCell
          colSpan={1}
          align='center'
          sx={{ backgroundColor: '#6b8d3e', fontWeight: 'bold', textTransform: 'capitalize' }}
        >
          {row}
        </TableCell>
      </>
    ));

    return render;
  };
  const renderChildCell = () => {
    const render = months?.map((row, i) => (
      <>
        <TableCell align='center'>
          {!prdResult.loading && parseInt(prdResult?.items[0][`${months[i]}_percent`]) > 0 ? (
            <>
              <CircleIcon
                sx={{
                  color: percentageColor(parseFloat(prdResult?.items[0][`${months[i]}_percent`])),
                }}
              />
              <br />
              {parseFloat(prdResult?.items[0][`${months[i]}_percent`])}%
            </>
          ) : (
            <CircleIcon
              sx={{
                color: '#c9c8c8',
              }}
            />
          )}
        </TableCell>
      </>
    ));
    return render;
  };
  return (
    <>
      {prdResult?.loading ? (
        <LinearProgress />
      ) : (
        <TableContainer component={Paper}>
          <Table aria-label='grouped table'>
            <TableHead>
              {/* First level of headers (grouped) */}
              <TableRow>
                <TableCell
                  rowSpan={2}
                  align='center'
                  sx={{ backgroundColor: '#88a364', fontWeight: 'bold', width: '300px' }}
                >
                  PRD RYG Result
                </TableCell>
                {renderParentCell()}
              </TableRow>
              {/* Second level of headers (individual columns) */}
              <TableRow>{renderChildCell()}</TableRow>
            </TableHead>
            <TableBody>{/* ... table body rows ... */}</TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
